import type { HierarchyForDagData } from '@/hooks/useHierarchyForDag'
import type { DropdownOptionRead } from '@/types/dag'

export type HierarchyLevel = 'division' | 'department' | 'class' | 'subclass'

export function getHierarchyOptionsForLevel(
  hierarchyLevel: HierarchyLevel,
  rowCells: Record<string, unknown>,
  hierarchyData: HierarchyForDagData
): DropdownOptionRead[] {
  switch (hierarchyLevel) {
    case 'division':
      return hierarchyData.divisionOptions
    case 'department': {
      const div = rowCells['division']
      return hierarchyData.getDepartmentOptions(
        div != null ? String(div) : null
      )
    }
    case 'class': {
      const dept = rowCells['department']
      return hierarchyData.getClassOptions(dept != null ? String(dept) : null)
    }
    case 'subclass': {
      const cls = rowCells['class']
      return hierarchyData.getSubclassOptions(cls != null ? String(cls) : null)
    }
  }
}
